<div class="contentContainer">
	<main class="contentContainer-main" role="main">
		<form
			*ngIf="fulfilmentTimeSlotForm"
			[formGroup]="fulfilmentTimeSlotForm"
			(submit)="reserveSlot(true)"
			cdxForm
			#form
			data-cy="form"
		>
			<wnz-funnel-breadcrumbs [inset]="false" *ngIf="isInCheckout"></wnz-funnel-breadcrumbs>
			<section>
				<h3>Delivery or Pick up?</h3>

				<fulfilment-method-selection [formGroup]="fulfilmentTimeSlotForm" controlName="method">
				</fulfilment-method-selection>

				<wnz-delivery-saver-tag
					*ngIf="!hasActiveDeliverySubscription && getCurrentFulfilmentMethod() === 'Delivery'"
				></wnz-delivery-saver-tag>

				<fieldset
					class="bookTimeSlot-details"
					cdxFieldset
					[divider]="true"
					legend="Address"
					[hideLegend]="true"
					layout="large"
					[i18n]="'@@howWhereWhen-address'"
				>
					<div>
						<div>
							<cdx-alert
								[animate]="false"
								[description]="deliverySubscriptionAlert?.description"
								[title]="deliverySubscriptionAlert?.title"
								[type]="deliverySubscriptionAlert?.alertType"
								*ngIf="deliverySubscriptionAlert"
								data-cy="hwwDeliverySubscriptionAlert"
							></cdx-alert>
							<cdx-alert
								[animate]="false"
								[description]="reducedRangeAlert?.description"
								[title]="reducedRangeAlert?.title"
								[type]="reducedRangeAlert?.alertType"
								*ngIf="reducedRangeAlert"
								data-cy="hwwReducedRangeAlert"
							></cdx-alert>
							<p>
								<span data-cy="addressLabel">{{ addressLabel }}</span>
								<br />
								<strong data-cy="address">{{ address }}</strong>
								<button
									data-cy="link"
									cdxButton
									(click)="openAddressOrStoreSelection()"
									fillStyle="link"
									size="small"
									[inline]="true"
									type="button"
									[endSlotActive]="true"
									endSlotSize="extra-small"
								>
									{{ addressLink }}
									<cdx-svg-icon name="chevron-right" fill="green" size="extra-small" end></cdx-svg-icon>
								</button>
							</p>
						</div>
					</div>
				</fieldset>
			</section>
			<section *ngIf="inDeliveryZone" data-cy="hwwTimeslotHeader">
				<h3>Choose a time</h3>
				<fulfilment-date-selection [formGroup]="fulfilmentTimeSlotForm" controlName="day"> </fulfilment-date-selection>
			</section>

			<section *ngIf="showExpressSlot" class="bookTimeSlot-slots" data-cy="hwwExpressTimelots">
				<h4 class="heading--5" id="fullstory-express-pickup-title">
					{{getExpressFulfilmentMethodLabel()}}<span class="bookTimeSlot-slotInfo">
						- {{ getExpressFulfilmentFee() | currency:'NZD':'symbol-narrow':'1.0-0' }} for up to
						{{getExpressFulfilmentMaxItems()}} items</span>
					<button
						cdxButton
						(click)="openDeliveryFeesModal(true)"
						fillStyle="link"
						size="small"
						[inline]="true"
						type="button"
						[endSlotActive]="true"
						class="bookTimeSlot-deliveryInfoButton"
						endSlotSize="extra-small"
					>
						<span class="sr-only">{{getFulfilmentMethodLabel()}} information</span>
						<cdx-svg-icon name="hint" fill="dark" size="small"></cdx-svg-icon>
					</button>
				</h4>
				<fulfilment-time-selection
					[formGroup]="fulfilmentTimeSlotForm"
					controlName="slot"
          [selectedSlotId]="selectedSlot"
					[date]="currentDate"
					(openModalClicked)="openPickupHelpModal()"
					(openPickupPointInformationModal)="openPickupPointInformationModal()"
					(openDualOfferInformationModal)="openDualOfferInformationModal()"
					(openDirectToBootOnlyInformationModal)="openDirectToBootOnlyInformationModal()"
					[isExpressPickup]="true"
					[expressSlotStatus]="expressSlotStatus"
					(openDeliveryFeesModal)="openDeliveryFeesModal(false)"
					[slotsHeadingPricingText]="getTimeSlotsHeadingPricingText()"
					[timeSlotsHeadingText]="getTimeSlotsHeadingText()"
				></fulfilment-time-selection>
			</section>

			<section *ngIf="showFlexibleSlot && isFlexibleDeliveryEnabledV2" class="bookTimeSlot-slots" data-cy="hwwFlexibleDeliveryTimeSlots">
				<h4 class="heading--5" id="fullstory-flexible-delivery-title">
					{{getFlexibleFulfilmentMethodLabel()}}<span class="bookTimeSlot-slotInfo">
						- {{ getFlexibleFulfilmentFee() | currency:'NZD':'symbol-narrow':'1.0-0' }}
						<ng-container *ngIf="getFlexibleDeliveryMaxItems()">for up to {{ getFlexibleDeliveryMaxItems() }} items
						</ng-container>
					</span>
					<button
						cdxButton
						(click)="openFlexibleDeliveryFeesModal()"
						fillStyle="link"
						size="small"
						[inline]="true"
						type="button"
						[endSlotActive]="true"
						class="bookTimeSlot-deliveryInfoButton"
						endSlotSize="extra-small"
					>
						<span class="sr-only">{{getFulfilmentMethodLabel()}} information</span>
						<cdx-svg-icon name="hint" fill="dark" size="small"></cdx-svg-icon>
					</button>
					<div class="bookTimeSlot-subTitle"> Delivered by our Partner Drivers</div>
				</h4>
				<fulfilment-flexible-delivery-slot-selection *ngIf="!multipleFlexibleSlotsAvailable"
					[slot]="getSelectedFlexibleSlot()"
					controlName="slot"
					[date]="currentDate"
					[formGroup]="fulfilmentTimeSlotForm"
					[isSingleSlot]="true"
					[isFlexibleDeliveryV2]="true"
					[hasChevron]="false">
				</fulfilment-flexible-delivery-slot-selection>
				
				<div *ngIf="multipleFlexibleSlotsAvailable"
					cdxButton
					fillStyle="link"
					(click)="openFlexibleSlotSelection()"
					class="flexibleButton"
					size="fullWidth"
					[inline]="true"
					type="button"
					[endSlotActive]="true"
					endSlotSize="extra-small"
					>
					<fulfilment-flexible-delivery-slot-selection
						[slot]="getSelectedFlexibleSlot()"
						controlName="slot"
						[date]="currentDate"
						[formGroup]="fulfilmentTimeSlotForm"
						[isSingleSlot]="false"
						[isFlexibleDeliveryV2]="true"
						[hasChevron]="true">
					</fulfilment-flexible-delivery-slot-selection>
				</div>
			</section>

			<section *ngIf="showFlexibleSlot && !isFlexibleDeliveryEnabledV2" class="bookTimeSlot-slots" data-cy="hwwFlexibleDeliveryTimeSlots">
				<h4 class="heading--5" id="fullstory-flexible-delivery-title">
					{{getFlexibleFulfilmentMethodLabel()}}<span class="bookTimeSlot-slotInfo">
						- {{ getFlexibleFulfilmentFee() | currency:'NZD':'symbol-narrow':'1.0-0' }} per order</span>
				</h4>
				<fulfilment-time-selection
					[formGroup]="fulfilmentTimeSlotForm"
					controlName="slot"
          [selectedSlotId]="selectedSlot"
					[date]="currentDate"
					[isFlexibleDelivery]="true"
				></fulfilment-time-selection>
			</section>

			<section *ngIf="inDeliveryZone && currentDate && showStandardPickup()" class="bookTimeSlot-slots" data-cy="hwwTimeslots">
				<h4 class="heading--5">
					{{getTimeSlotsHeadingText()}}
					<span class="bookTimeSlot-slotInfo">{{getTimeSlotsHeadingPricingText()  }}</span>
					<button
						cdxButton
						(click)="openDeliveryFeesModal(false)"
						fillStyle="link"
						size="small"
						[inline]="true"
						type="button"
						[endSlotActive]="true"
						class="bookTimeSlot-deliveryInfoButton"
						endSlotSize="extra-small"
					>
						<span class="sr-only">{{getCurrentFulfilmentMethod()}} information</span>
						<cdx-svg-icon name="hint" fill="dark" size="small"></cdx-svg-icon>
					</button>
				</h4>
				<fulfilment-time-selection
					[formGroup]="fulfilmentTimeSlotForm"
					controlName="slot"
          [selectedSlotId]="selectedSlot"
					[date]="currentDate"
					(openModalClicked)="openPickupHelpModal()"
					(openPickupPointInformationModal)="openPickupPointInformationModal()"
					(openDualOfferInformationModal)="openDualOfferInformationModal()"
					(openDirectToBootOnlyInformationModal)="openDirectToBootOnlyInformationModal()"
				></fulfilment-time-selection>
			</section>

			<section class="actionBar" [ngClass]="{'actionBar--leftAligned':!inDeliveryZone}">
				<button
					*ngIf="!isInCheckout"
					attr.aria-label="Save slot selection and go back to shopping"
					i18n="@@howWhereWhen-keepShoppingButton"
					class="actionBar-keepShoppingButton"
					cdxButton
					type="button"
					[fillStyle]="showContinueButton ? 'outline' : 'primary'"
					[buttonState]="keepShoppingButtonState"
					(click)="handleKeepShoppingClick(form)"
				>
					Keep shopping
				</button>
				<button
					*ngIf="showContinueButton"
					attr.aria-label="Save slot selection and continue to checkout"
					i18n="@@howWhereWhen-continueButton"
					class="actionBar-continueButton"
					cdxButton
					type="submit"
					[buttonState]="continueButtonState"
					[disabled]="!form.canSubmit"
				>
					{{ isInCheckout ? 'Continue' : 'Continue to Checkout' }}
				</button>
			</section>
		</form>
	</main>
</div>
<router-outlet name="hww-modal"></router-outlet>
